import { Component, Input } from '@angular/core';
import { AppStreamEnvironment } from '../../api/erm-capability/models/AppStreamEnvironment';

@Component({
  standalone: false,
  selector: 'lib-env-status',
  templateUrl: './env-status.component.html',
  styleUrls: ['./env-status.component.scss']
})
export class EnvironmentStatusComponent {
  @Input() env?: AppStreamEnvironment;
}
